//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
export default {
  name: 'FormReportRegion',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      valid: false,
      regionToAdd: null,
      region_id: 0,
      regionsList: [],
      id_region_dataentry: 0
    };
  },
  created: function created() {
    this.getRegions();
  },
  methods: {
    validate: function validate() {
      return this.$refs.formAddRegion.validate();
    },
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      var params = {
        region: this.regionToAdd,
        id_region_dataentry: this.id_region_dataentry
      };
      this.$emit('SubmitReport', params);
    },
    getRegions: function getRegions() {
      var _this = this;
      Somos1DataEntryService.getRegionsList().then(function (response) {
        if (response && response.data) {
          _this.regionsList = response.data;
        }
      });
    }
  },
  computed: {}
};